import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, { CSVExport, Search, } from "react-bootstrap-table2-toolkit";
import { faPlus, faSearch, faDownload } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getCustomerEntry } from "../../Service/AllCustomerEntryAPI";
import { getCustomerList } from "../master/AllUserDropDown";
import { getCustomerWise } from "../../Service/AllReportAPI";
import moment from "moment";
import swal from "sweetalert";

//import * as Yup from "yup";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  const [customerName, setCustomerName] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  // --- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);

  useEffect(() => {
    // Function call to get Dispatch list
    getCustomersList();
    getAllCustomerList();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (selectedCustomer === "") {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getCustomerEntry(selectedPage, headers)
      .then((result) => {
        console.log("Get Pagination Dispatch Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          console.log("data", data);
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          entries.map((item, index) => (item.id = totalSize + index + 1));
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    }
      //Customer wise pagination
      else if (selectedCustomer !== "") {
        await getCustomerWise(selectedPage,selectedCustomer)
        .then((result) => {
          console.log("Get Pagination Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
          } else {
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    }
  };

  const getAllCustomerList = async () => {
    try {
      setisLoaded(true);
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getCustomerEntry(currentPage, headers)
      .then((result) => {
        setisLoaded(false);
        console.log("Get Customer Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);
        } else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Get Customer Entry Error", error);
      });
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getCustomerWisePdfDownload = async (e) => {
    try {
      if (selectedCustomer !== "") {
        setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["Pdf"];
        return Axios.get(
          `customerNameWiseCustomerReportPdf?fileType=${fileType}&customerName=${selectedCustomer}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          setisLoaded(false);
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `customernamewisecustomerreport.pdf`);
        });
      } else {
        swal("Failed", "Please select Customer Name", "error");
      }
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getCustomerWiseExcelDownload =  async (e) => {
    try {
      if (selectedCustomer !== "") {
        let token = sessionStorage.getItem("token");
        let fileType = ["Excel"];
        return Axios.get(`customerNameWiseCustomerReportPdf?fileType=${fileType}&customerName=${selectedCustomer}`, {
          headers: {Authorization: `Bearer ${token}`},
          responseType: "arraybuffer",
        })
        .then((result) => {
          let blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          fileSaver.saveAs(blob, "customerListByCustomerNameExcel.xlsx");
        });
      } else {
        swal("Failed", "Please Select Dealer Name", "warning");
      }
    } catch (error) {
      console.log("getCustomerWiseExcelDownload error :-", error);
      swal("Failed", "Something went wrong please check your internet");
    };
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of Customer list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerEmailId",
      text: "Registered Email",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerMobileNo",
      text: "Registered Mobile No.",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "contactPersonName",
      text: "Contact Person Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "userName",
      text: "Username",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "contactPersonDesignation",
      text: "Contact Designation",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "contactEmailId",
      text: "Contact Email",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "contactPhoneNo",
      text: "Contact Mobile No.",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "discription",
      text: "Description",
      editable: false,
      headerAlign: "left",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.discription}</span>
          )}
        </div>
      )
    },
    {
      dataField: "customerAddress",
      text: "Address",
      editable: false,
      style: { textTransform: "capitalize"},
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.customerAddress}</span>
          )}
        </div>
      )
    },
  
    {
      dataField: "country",
      text: "Country",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "state",
      text: "State",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "city",
      text: "City",
      editable: false,
      headerAlign: "left",
    },
    
    {
      dataField: "pinCode",
      text: "Pin Code",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "siteName",
      text: "Site Name",
      editable: false,
      headerAlign: "left",
    },
    
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <Formik
          initialValues={{}}
          onSubmit={async (values) => {
            console.log(JSON.stringify(values, null, 2));
          }}
        >
          {(formik) => {
            return (
              <>
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="Label mb-1">Customer Name</label>
                      <Select
                        name="customerName"
                        placeholder="Select Customer Name"
                        title="Select Customer Name"
                        options={customerName}
                        onChange={async (e) => {
                          formik.setFieldValue("customerName", e.value);
                          setSelectedCustomer(e.value);
                          await getCustomerWise(currentPage,e.value)
                          .then((result) => {
                            console.log("Customer Details", result.data);
                            if (result?.data?.content?.length !== 0) {
                              const data = result.data.content;
                              setEntries(data);
                              setPageCount(result.data.totalPages);
                              setTotalCount(result.data.totalElements);
                            } else {
                              setEntries([]);
                              setPageCount();
                              setTotalCount();
                              swal("Sorry", "Data is not present", "warning");
                            }
                          })
                          .catch((error) => {
                            console.log("Dispatch Error", error);
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
{/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    //render the Pagination component as a list with left and right arrows
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        disablePageTitle: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange : handlePageChange,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1">
                                  {/* <Paginator.SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  <button
                                    className="btn btn-secondary mx-2"
                                    onClick={getCustomerWisePdfDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>PDF</span>{" "}
                                  </button>
                                  <button
                                    className="btn btn-secondary"
                                    onClick={getCustomerWiseExcelDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            <Table
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                              // selectRow={selectRow}
                              headerClasses="header-class"
                              hover
                              striped
                              condensed
                              filter={filterFactory()}
                              remote= {{pagination:true}}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (
                                  oldValue,
                                  newValue,
                                  row,
                                  column
                                ) => {
                                  const changeRowData = {
                                    selectedRow: row,
                                    cellChange: newValue,
                                    columnChange: column,
                                  };
                                  setChangeRowData(changeRowData);
                                },
                              })}
                              wrapperClasses="table-responsive"
                            />
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                >
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>
            );
          }}
        </Formik>
      )}
    </>
  );
};
// }};
